import type { RouteObject } from "react-router-dom";
import LandingPage from "../pages/landing/page";

const routes: RouteObject[] = [
  {
    path: "*",
    element: <LandingPage />,
  },
];

export default routes;
